<script setup lang="ts">
import UiAction from '@/components/core/UiAction.vue';
import UiIcon from '@/components/core/UiIcon.vue';
import AppAction from '@/models/core/AppAction';

const props = defineProps<{
  action: AppAction;
}>();
</script>

<template>
  <UiAction
    :action="props.action"
    class="group ui-touch ui-outline hover:ui-outline-active max-desktop:flex-col max-desktop:justify-center desktop:gap-4 desktop:py-3 desktop:pr-8 desktop:pl-3 flex items-center gap-6 rounded"
  >
    <div class="ui-bg-primary group-active:text-app-base desktop:p-3 rounded-full p-6 group-active:bg-stone-50">
      <UiIcon v-if="props.action.icon" :path="props.action.icon" class="desktop:h-8 desktop:w-8 h-12 w-12" />
    </div>
    <span class="desktop:text-lg text-2xl font-medium">{{ props.action.label }}</span>
  </UiAction>
</template>
